<div class="tunnel-page-container">
  <div class="body-container">
    <div class="basket-product-container">
      <ng-casto-tunnel-product-search></ng-casto-tunnel-product-search>
      <ng-casto-tunnel-cart-panel></ng-casto-tunnel-cart-panel>
    </div>
  </div>

  <div class="action-bar-container">
    <ng-casto-action-bar></ng-casto-action-bar>
  </div>
</div>
